import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { imageURL, productBaseURL } from "../../../../../Services/api/baseURL";
import dummyImg from '../../../../../assets/images/product/2.png';
import { Field, TextInput, NumberInput, Select, TextArea, Toggle } from "./formControls";

const labelOptions = [
  { value: "hot", label: "Hot" },
  { value: "bestseller", label: "Bestseller" },
  { value: "new", label: "New" },
  { value: "premium", label: "Premium" },
  { value: "high_strength", label: "High Strength" },
  { value: "exotic", label: "Exotic" },
  { value: "bundles", label: "Bundles" },
  { value: "biggest_saving", label: "Biggest Saving" },
  { value: "world_tour", label: "World Tour" },
  { value: "spot_light", label: "Spot Light" },
  { value: "none", label: "None" },
];

export const DetailsTab = ({ form, updateField }) => {
  const [isUploading, setIsUploading] = useState(false);

  const onImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setIsUploading(true);
    try {
      const token = await JSON.parse(localStorage.getItem("token"));
      const formData = new FormData();
      formData.append("Image", file);
      const response = await axios.post(`${productBaseURL}/variants/upload`, formData, {
        headers: { Authorization: `${token}`, "Content-Type": "multipart/form-data" },
      });
      if (response.data.success) {
        updateField("variantImage", response?.data?.data?.image);
        toast.success("Image uploaded");
      }
    } catch (error) {
      console.error(error);
      toast.error("Image upload failed");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-4">
        <img
          src={form?.variantImage ? imageURL + form.variantImage : dummyImg}
          alt="variant"
          className="h-16 w-16 rounded-lg border border-gray-200 object-cover"
        />
        <label className="cursor-pointer rounded-lg border border-dashed border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-600 hover:border-pink-400 hover:text-pink-600">
          {isUploading ? "Uploading..." : "Change Image"}
          <input type="file" onChange={onImageUpload} className="hidden" />
        </label>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Field label="Bar Code">
          <TextInput value={form?.variantCode || ""} onChange={(e) => updateField("variantCode", e.target.value)} />
        </Field>
        <Field label="Variant Name">
          <TextInput value={form?.variantName || ""} onChange={(e) => updateField("variantName", e.target.value)} />
        </Field>
        <Field label="Volume">
          <TextInput value={form?.vol || ""} onChange={(e) => updateField("vol", e.target.value)} />
        </Field>
        <Field label="Alcohol %">
          <NumberInput value={form?.alcohol_percentage ?? 0} onChange={(e) => updateField("alcohol_percentage", Number(e.target.value))} />
        </Field>
        <Field label="Purchase Price">
          <NumberInput value={form?.purchasePrice ?? 0} onChange={(e) => updateField("purchasePrice", Number(e.target.value))} />
        </Field>
        <Field label="Quantity">
          <NumberInput value={form?.quantity ?? 0} onChange={(e) => updateField("quantity", Number(e.target.value))} />
        </Field>
        <Field label="Label">
          <Select value={form?.label || "none"} onChange={(e) => updateField("label", e.target.value)}>
            {labelOptions.map((opt) => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
          </Select>
        </Field>
      </div>

      <Field label="Description">
        <TextArea rows={3} value={form?.description || ""} onChange={(e) => updateField("description", e.target.value)} />
      </Field>

      <div className="flex flex-wrap gap-8">
        <div className="flex items-center gap-3">
          <Toggle
            id="topSelling"
            checked={!!form?.isTopSellingProduct}
            onChange={(e) => updateField("isTopSellingProduct", e.target.checked)}
          />
          <span className="text-sm font-medium text-gray-700">Top Selling Product</span>
        </div>
        <div className="flex items-center gap-3">
          <Toggle
            id="activeStatus"
            checked={form?.status === "active"}
            onChange={(e) => updateField("status", e.target.checked ? "active" : "inactive")}
          />
          <span className="text-sm font-medium text-gray-700">Active</span>
        </div>
      </div>
    </div>
  );
};